export interface StartupPolicySettings {
  enabled: boolean;
  applyAtStartup: boolean;
  checkIntervalMinutes: number;
  downloadTimeoutSeconds: number;
  allowCellular: boolean;
}
export interface StartupPolicyConfig extends StartupPolicySettings { revision: number; updatedAt: string; updatedBy: string }
export const DEFAULT_STARTUP_POLICY: StartupPolicySettings = {
  enabled: true, applyAtStartup: true, checkIntervalMinutes: 0, downloadTimeoutSeconds: 60, allowCellular: true,
};
